module.exports = __webpack_public_path__ + "img/turbo-features4.517f5e8d.png";